// extracted by mini-css-extract-plugin
export default {"header":"ProductsList_header__u8ygK","row":"ProductsList_row__z3q5C"};